<script lang="ts">
    import Fa from 'svelte-fa'
    import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import { ServiceOnQuotation } from '../../../modules/posApi/quotation/quotation.entity'
    import ZentitySelect from '../../_common/z/zentity-select.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }
    export let item: Partial<ServiceOnQuotation> = undefined

    // abre um item já existente direto em edição (a folha do mobile desenha a linha fechada por conta
    // própria e só usa este componente para editar). No desktop fica desligado.
    export let startEditing: boolean = false

    let step = 1
    let isNew = false
    async function editEntity() {
        step = 2
    }

    async function newEntity() {
        isNew = true
        step = 2
        item = new ServiceOnQuotation()
    }

    async function cancelEntity() {
        item = undefined
        step = 1
        dispatch('cancel')
    }

    async function confirmEntity() {
        if (item.service?.type !== 'package') {
            if (!item.service || !item.quantity) {
                window.error('Informe todas as opções antes de confirmar.')
                return
            }
            if (!item.value && item.value !== 0) {
                window.error('Informe o valor antes de confirmar.')
                return
            }
        }
        dispatch('added', item)
        if (isNew) item = undefined
        step = 1
        isNew = false
    }

    onMount(() => {
        if (!item) newEntity()
        else if (startEditing) step = 2
    })

    let lastService = null
    $: {
        if (isNew) {
            if (item && item.service && item?.service != lastService) {
                lastService = item?.service
                if (item.service?.type !== 'package') {
                    if (!item?.quantity) item.quantity = 1
                    item.value = item.service?.price
                } else {
                    if (!item?.quantity) item.quantity = 0
                    item.value = 0
                }
            }
        }
    }

    function friendlyType(type: string) {
        if (type === 'service') return 'Serviço'
        if (type === 'package') return 'Pacote'
        if (type === 'product') return 'Produto'
        return type
    }
</script>

{#if item !== undefined}
    <div class={className}>
        {#if step === 1}
            <div class="row line h-mobile">
                <div class="col nowrap package_{!!item.parentServiceId}">
                    {#if !item.parentServiceId}
                        <div class="badge badge_{item.service?.type}">
                            {friendlyType(item.service?.type)}
                        </div>
                    {:else}
                        <div class="badge">●</div>
                    {/if}
                    {item.service?.name}
                </div>
                {#if item?.service?.type !== 'package'}
                    <div class="col-md-1 text-end">{window.api.utils.utils.toReal(item.value)}</div>
                    <div class="col-md-1 text-end">{item.quantity}</div>
                    <div class="col-md-1 text-end">{window.api.utils.utils.toReal(item.value * item.quantity) || ' -'}</div>
                {/if}
                <div class="col-md-2 text-end">
                    <button
                        class="btn btn-secondary btn-sm btn-package_{!!item?.parentServiceId}"
                        on:click={() => {
                            editEntity()
                        }}><Fa icon={faEdit} /> Editar</button
                    >
                </div>
            </div>
            <div class="row line h-full content">
                <div class="col-6">
                    <div class="label">Item</div>
                    <div class="item nowrap">{item.service?.name}</div>
                </div>
                <div class="col-3">
                    <div class="label">Total</div>
                    <div class="item">{window.api.utils.utils.toReal(item.value * item.quantity) || ' -'}</div>
                </div>

                <div class="col-3 text-center">
                    <button
                        class="btn btn-secondary btn-sm mt-3 mb-2"
                        on:click={() => {
                            editEntity()
                        }}><Fa icon={faEdit} /> Editar</button
                    >
                </div>
            </div>
        {/if}
        {#if step === 2}
            <!-- tudo numa linha só, como no PDV: os botões fecham a linha, sem rótulo — a lixeira e o
                 certo já dizem o que fazem, e com rótulo não sobraria largura para os campos -->
            <ZContainer gapRow="8px" gapCol="8px">
                <ZContainerCol size={5} sizeM={12}>
                    <ZentitySelect fonte="servico" label="Item" params={{ type: 'all', price: true }} bind:value={item.service} />
                </ZContainerCol>
                <!-- as colunas existem mesmo vazias: pacote tem preço fechado e não mostra os campos,
                     mas os botões continuam no fim da linha -->
                <ZContainerCol size={2} sizeM={4}>
                    {#if item.service && item.service.type !== 'package'}
                        <Zinput type="number" label="Vlr Unit" bind:value={item.value} />
                    {/if}
                </ZContainerCol>
                <ZContainerCol size={2} sizeM={4}>
                    {#if item.service && item.service.type !== 'package'}
                        <Zinput type="number" label="Qtde" bind:value={item.quantity} />
                    {/if}
                </ZContainerCol>
                <ZContainerCol size={2} sizeM={4}>
                    {#if item.service && item.service.type !== 'package'}
                        <Zinput type="number" label="Total" value={item.value * item.quantity} disabled={true} />
                    {/if}
                </ZContainerCol>
                <ZContainerCol size={1} sizeM={12} flex={true}>
                    <Zbutton grow={true} class="me-2" color="red" icon={faTrashAlt} title="Excluir" on:click={cancelEntity} />
                    <Zbutton grow={true} color="green" icon={faCheck} title="Confirmar" on:click={confirmEntity} />
                </ZContainerCol>
            </ZContainer>
        {/if}
    </div>
{/if}

<style>
    .package_true {
        padding-left: 60px;
        display: flex;
        align-items: center;
    }
    .btn-package_true {
        opacity: 0.6;
    }
    .package_false {
        display: flex;
        align-items: center;
    }

    /* o editor agora é ZContainer + Zinput: as larguras fixas por coluna saíram junto com o markup
       do Bootstrap que as usava */
</style>
